import { studyDownload } from '../../../utils/downloadStudy';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '../../../components/ui/button';
import { useState } from 'react';
import { Loader2 } from 'lucide-react';

interface DownloadButtonProps {
  studyInstanceUID: string;
  studyDescription: string;
  studyDate: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  studyInstanceUID,
  studyDescription,
  studyDate,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const authToken = await getAccessTokenSilently();
      await studyDownload(
        authToken,
        studyInstanceUID,
        studyDescription,
        studyDate
      );
      console.log('Downloaded');
    } catch (error) {
      console.error('Error triggering download:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      className="flex w-auto hover:bg-blue-600 hover:text-white transition-colors rounded"
      onClick={handleDownload}
      disabled={loading}
    >
      {loading ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null}
      {loading ? 'Downloading' : 'Download'}
    </Button>
  );
};
